module.exports = __webpack_public_path__ + "img/userAvatarIcon.56c31d28.svg";